import { ForwardRefExoticComponent } from 'react';

import WrapperMockComponent from '@hh.ru/magritte-ui-icon/WrapperMockComponent';
import { mockComponent } from '@hh.ru/magritte-ui-mock-component';

export { type IconColor, type IconDisabledColor } from '@hh.ru/magritte-ui-icon/types';

export const IconDynamic: ForwardRefExoticComponent<Record<string, unknown>> = mockComponent('IconDynamic', undefined, {
    withChildren: true,
});
export const AndroidBrandSize16 = mockComponent(
    'AndroidBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AndroidBrandSize24 = mockComponent(
    'AndroidBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AndroidGrayscaleSize16 = mockComponent(
    'AndroidGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AndroidGrayscaleSize24 = mockComponent(
    'AndroidGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AndroidSolidSize16 = mockComponent(
    'AndroidSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AndroidSolidSize24 = mockComponent(
    'AndroidSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AppleBrandAltSize16 = mockComponent(
    'AppleBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AppleBrandAltSize24 = mockComponent(
    'AppleBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AppleBrandSize16 = mockComponent(
    'AppleBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AppleBrandSize24 = mockComponent(
    'AppleBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AppleGrayscaleSize16 = mockComponent(
    'AppleGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AppleGrayscaleSize24 = mockComponent(
    'AppleGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AppleSolidSize16 = mockComponent(
    'AppleSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AppleSolidSize24 = mockComponent(
    'AppleSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClickmeBrandSize16 = mockComponent(
    'ClickmeBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClickmeBrandSize24 = mockComponent(
    'ClickmeBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClickmeGrayscaleSize16 = mockComponent(
    'ClickmeGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClickmeGrayscaleSize24 = mockComponent(
    'ClickmeGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClickmeSolidSize16 = mockComponent(
    'ClickmeSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClickmeSolidSize24 = mockComponent(
    'ClickmeSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DnrBrandSize16 = mockComponent(
    'DnrBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DnrBrandSize24 = mockComponent(
    'DnrBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DnrGrayscaleSize16 = mockComponent(
    'DnrGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DnrGrayscaleSize24 = mockComponent(
    'DnrGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DnrSolidSize16 = mockComponent(
    'DnrSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DnrSolidSize24 = mockComponent(
    'DnrSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobBrandSize16 = mockComponent(
    'DreamjobBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobBrandSize24 = mockComponent(
    'DreamjobBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobGrayscaleSize16 = mockComponent(
    'DreamjobGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobGrayscaleSize24 = mockComponent(
    'DreamjobGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobSolidSize16 = mockComponent(
    'DreamjobSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobSolidSize24 = mockComponent(
    'DreamjobSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DzenBrandSize16 = mockComponent(
    'DzenBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DzenBrandSize24 = mockComponent(
    'DzenBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DzenGrayscaleSize16 = mockComponent(
    'DzenGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DzenGrayscaleSize24 = mockComponent(
    'DzenGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DzenSolidSize16 = mockComponent(
    'DzenSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DzenSolidSize24 = mockComponent(
    'DzenSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EsiaBrandAltSize16 = mockComponent(
    'EsiaBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EsiaBrandAltSize24 = mockComponent(
    'EsiaBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EsiaBrandSize16 = mockComponent(
    'EsiaBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EsiaBrandSize24 = mockComponent(
    'EsiaBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EsiaGrayscaleSize16 = mockComponent(
    'EsiaGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EsiaGrayscaleSize24 = mockComponent(
    'EsiaGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EsiaSolidSize16 = mockComponent(
    'EsiaSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EsiaSolidSize24 = mockComponent(
    'EsiaSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FacebookBrandSize16 = mockComponent(
    'FacebookBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FacebookBrandSize24 = mockComponent(
    'FacebookBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FacebookGrayscaleSize16 = mockComponent(
    'FacebookGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FacebookGrayscaleSize24 = mockComponent(
    'FacebookGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FacebookSolidSize16 = mockComponent(
    'FacebookSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FacebookSolidSize24 = mockComponent(
    'FacebookSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlBrandSize16 = mockComponent(
    'FlBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlBrandSize24 = mockComponent(
    'FlBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlGrayscaleSize16 = mockComponent(
    'FlGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlGrayscaleSize24 = mockComponent(
    'FlGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlSolidSize16 = mockComponent(
    'FlSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlSolidSize24 = mockComponent(
    'FlSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GithubBrandSize16 = mockComponent(
    'GithubBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GithubBrandSize24 = mockComponent(
    'GithubBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GithubGrayscaleSize16 = mockComponent(
    'GithubGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GithubGrayscaleSize24 = mockComponent(
    'GithubGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GithubSolidSize16 = mockComponent(
    'GithubSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GithubSolidSize24 = mockComponent(
    'GithubSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GoogleBrandSize16 = mockComponent(
    'GoogleBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GoogleBrandSize24 = mockComponent(
    'GoogleBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GoogleGrayscaleSize16 = mockComponent(
    'GoogleGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GoogleGrayscaleSize24 = mockComponent(
    'GoogleGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GoogleSolidSize16 = mockComponent(
    'GoogleSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GoogleSolidSize24 = mockComponent(
    'GoogleSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBrandSize16 = mockComponent(
    'HhBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBrandSize24 = mockComponent(
    'HhBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppBrandSize16 = mockComponent(
    'HhBusinessAppBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppBrandSize24 = mockComponent(
    'HhBusinessAppBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppBrandSize48 = mockComponent(
    'HhBusinessAppBrandSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppGrayscaleSize16 = mockComponent(
    'HhBusinessAppGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppGrayscaleSize24 = mockComponent(
    'HhBusinessAppGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppGrayscaleSize48 = mockComponent(
    'HhBusinessAppGrayscaleSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppSolidSize16 = mockComponent(
    'HhBusinessAppSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppSolidSize24 = mockComponent(
    'HhBusinessAppSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhBusinessAppSolidSize48 = mockComponent(
    'HhBusinessAppSolidSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhGrayscaleSize16 = mockComponent(
    'HhGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhGrayscaleSize24 = mockComponent(
    'HhGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProBrandSize16 = mockComponent(
    'HhProBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProBrandSize24 = mockComponent(
    'HhProBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProBrandSize32 = mockComponent(
    'HhProBrandSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProGrayscaleSize16 = mockComponent(
    'HhProGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProGrayscaleSize24 = mockComponent(
    'HhProGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProGrayscaleSize32 = mockComponent(
    'HhProGrayscaleSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProSolidSize16 = mockComponent(
    'HhProSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProSolidSize24 = mockComponent(
    'HhProSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhProSolidSize32 = mockComponent(
    'HhProSolidSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhSolidSize16 = mockComponent(
    'HhSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HhSolidSize24 = mockComponent(
    'HhSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrLinkBrandSize16 = mockComponent(
    'HrLinkBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrLinkBrandSize24 = mockComponent(
    'HrLinkBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrLinkGrayscaleSize16 = mockComponent(
    'HrLinkGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrLinkGrayscaleSize24 = mockComponent(
    'HrLinkGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrLinkSolidSize16 = mockComponent(
    'HrLinkSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrLinkSolidSize24 = mockComponent(
    'HrLinkSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsBrandSize16 = mockComponent(
    'IbsBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsBrandSize24 = mockComponent(
    'IbsBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsBrandSize32 = mockComponent(
    'IbsBrandSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsGrayscaleSize16 = mockComponent(
    'IbsGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsGrayscaleSize24 = mockComponent(
    'IbsGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsGrayscaleSize32 = mockComponent(
    'IbsGrayscaleSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsSolidSize16 = mockComponent(
    'IbsSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsSolidSize24 = mockComponent(
    'IbsSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IbsSolidSize32 = mockComponent(
    'IbsSolidSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IcqBrandSize16 = mockComponent(
    'IcqBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IcqBrandSize24 = mockComponent(
    'IcqBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IcqGrayscaleSize16 = mockComponent(
    'IcqGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IcqGrayscaleSize24 = mockComponent(
    'IcqGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IcqSolidSize16 = mockComponent(
    'IcqSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IcqSolidSize24 = mockComponent(
    'IcqSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImessageBrandSize16 = mockComponent(
    'ImessageBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImessageBrandSize24 = mockComponent(
    'ImessageBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImessageGrayscaleSize16 = mockComponent(
    'ImessageGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImessageGrayscaleSize24 = mockComponent(
    'ImessageGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImessageSolidSize16 = mockComponent(
    'ImessageSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImessageSolidSize24 = mockComponent(
    'ImessageSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IndexBrandSize16 = mockComponent(
    'IndexBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IndexBrandSize24 = mockComponent(
    'IndexBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IndexGrayscaleSize16 = mockComponent(
    'IndexGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IndexGrayscaleSize24 = mockComponent(
    'IndexGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IndexSolidSize16 = mockComponent(
    'IndexSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IndexSolidSize24 = mockComponent(
    'IndexSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InstagramBrandSize16 = mockComponent(
    'InstagramBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InstagramBrandSize24 = mockComponent(
    'InstagramBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InstagramGrayscaleSize16 = mockComponent(
    'InstagramGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InstagramGrayscaleSize24 = mockComponent(
    'InstagramGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InstagramSolidSize16 = mockComponent(
    'InstagramSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InstagramSolidSize24 = mockComponent(
    'InstagramSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LinkedinBrandSize16 = mockComponent(
    'LinkedinBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LinkedinBrandSize24 = mockComponent(
    'LinkedinBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LinkedinGrayscaleSize16 = mockComponent(
    'LinkedinGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LinkedinGrayscaleSize24 = mockComponent(
    'LinkedinGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LinkedinSolidSize16 = mockComponent(
    'LinkedinSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LinkedinSolidSize24 = mockComponent(
    'LinkedinSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LivejournalBrandSize16 = mockComponent(
    'LivejournalBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LivejournalBrandSize24 = mockComponent(
    'LivejournalBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LivejournalGrayscaleSize16 = mockComponent(
    'LivejournalGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LivejournalGrayscaleSize24 = mockComponent(
    'LivejournalGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LivejournalSolidSize16 = mockComponent(
    'LivejournalSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LivejournalSolidSize24 = mockComponent(
    'LivejournalSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MailBrandAltSize16 = mockComponent(
    'MailBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MailBrandAltSize24 = mockComponent(
    'MailBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MailBrandSize16 = mockComponent(
    'MailBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MailBrandSize24 = mockComponent(
    'MailBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MailGrayscaleSize16 = mockComponent(
    'MailGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MailGrayscaleSize24 = mockComponent(
    'MailGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MailSolidSize16 = mockComponent(
    'MailSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MailSolidSize24 = mockComponent(
    'MailSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxBrandSize16 = mockComponent(
    'MaxBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxBrandSize24 = mockComponent(
    'MaxBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxGrayscaleSize16 = mockComponent(
    'MaxGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxGrayscaleSize24 = mockComponent(
    'MaxGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxSolidSize16 = mockComponent(
    'MaxSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxSolidSize24 = mockComponent(
    'MaxSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxSquareBrandSize16 = mockComponent(
    'MaxSquareBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxSquareBrandSize24 = mockComponent(
    'MaxSquareBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxSquareGrayscaleSize16 = mockComponent(
    'MaxSquareGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxSquareGrayscaleSize24 = mockComponent(
    'MaxSquareGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxSquareSolidSize16 = mockComponent(
    'MaxSquareSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MaxSquareSolidSize24 = mockComponent(
    'MaxSquareSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MediumBrandSize16 = mockComponent(
    'MediumBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MediumBrandSize24 = mockComponent(
    'MediumBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MediumSize16 = mockComponent(
    'MediumSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MediumSize24 = mockComponent(
    'MediumSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MediumSolidSize16 = mockComponent(
    'MediumSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MediumSolidSize24 = mockComponent(
    'MediumSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OkBrandAltSize16 = mockComponent(
    'OkBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OkBrandAltSize24 = mockComponent(
    'OkBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OkBrandSize16 = mockComponent(
    'OkBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OkBrandSize24 = mockComponent(
    'OkBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OkGrayscaleSize16 = mockComponent(
    'OkGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OkGrayscaleSize24 = mockComponent(
    'OkGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OkSolidSize16 = mockComponent(
    'OkSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OkSolidSize24 = mockComponent(
    'OkSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCBrandSize16 = mockComponent(
    'OneCBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCBrandSize24 = mockComponent(
    'OneCBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCBrandSize32 = mockComponent(
    'OneCBrandSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCGrayscaleSize16 = mockComponent(
    'OneCGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCGrayscaleSize24 = mockComponent(
    'OneCGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCGrayscaleSize32 = mockComponent(
    'OneCGrayscaleSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCSolidSize16 = mockComponent(
    'OneCSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCSolidSize24 = mockComponent(
    'OneCSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OneCSolidSize32 = mockComponent(
    'OneCSolidSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppBrandAltSize16 = mockComponent(
    'RabotaByAppBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppBrandAltSize24 = mockComponent(
    'RabotaByAppBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppBrandAltSize48 = mockComponent(
    'RabotaByAppBrandAltSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppBrandSize16 = mockComponent(
    'RabotaByAppBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppBrandSize24 = mockComponent(
    'RabotaByAppBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppBrandSize48 = mockComponent(
    'RabotaByAppBrandSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppGrayscaleSize16 = mockComponent(
    'RabotaByAppGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppGrayscaleSize24 = mockComponent(
    'RabotaByAppGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppGrayscaleSize48 = mockComponent(
    'RabotaByAppGrayscaleSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppSolidSize16 = mockComponent(
    'RabotaByAppSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppSolidSize24 = mockComponent(
    'RabotaByAppSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByAppSolidSize48 = mockComponent(
    'RabotaByAppSolidSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByBrandSize16 = mockComponent(
    'RabotaByBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByBrandSize24 = mockComponent(
    'RabotaByBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByGrayscaleSize16 = mockComponent(
    'RabotaByGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaByGrayscaleSize24 = mockComponent(
    'RabotaByGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaBySolidSize16 = mockComponent(
    'RabotaBySolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RabotaBySolidSize24 = mockComponent(
    'RabotaBySolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaBrandSize16 = mockComponent(
    'SetkaBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaBrandSize24 = mockComponent(
    'SetkaBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaBrandSize32 = mockComponent(
    'SetkaBrandSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaBrandSize48 = mockComponent(
    'SetkaBrandSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaGrayscaleSize16 = mockComponent(
    'SetkaGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaGrayscaleSize24 = mockComponent(
    'SetkaGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaGrayscaleSize32 = mockComponent(
    'SetkaGrayscaleSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaGrayscaleSize48 = mockComponent(
    'SetkaGrayscaleSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaSolidSize16 = mockComponent(
    'SetkaSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaSolidSize24 = mockComponent(
    'SetkaSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaSolidSize32 = mockComponent(
    'SetkaSolidSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SetkaSolidSize48 = mockComponent(
    'SetkaSolidSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkillazBrandSize16 = mockComponent(
    'SkillazBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkillazBrandSize24 = mockComponent(
    'SkillazBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkypeBrandSize16 = mockComponent(
    'SkypeBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkypeBrandSize24 = mockComponent(
    'SkypeBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkypeGrayscaleSize16 = mockComponent(
    'SkypeGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkypeGrayscaleSize24 = mockComponent(
    'SkypeGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkypeSolidSize16 = mockComponent(
    'SkypeSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkypeSolidSize24 = mockComponent(
    'SkypeSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StackoverflowBrandSize16 = mockComponent(
    'StackoverflowBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StackoverflowBrandSize24 = mockComponent(
    'StackoverflowBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StackoverflowGrayscaleSize16 = mockComponent(
    'StackoverflowGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StackoverflowGrayscaleSize24 = mockComponent(
    'StackoverflowGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StackoverflowSolidSize16 = mockComponent(
    'StackoverflowSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StackoverflowSolidSize24 = mockComponent(
    'StackoverflowSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TalantixBrandSize16 = mockComponent(
    'TalantixBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TalantixBrandSize24 = mockComponent(
    'TalantixBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TalantixGrayscaleSize16 = mockComponent(
    'TalantixGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TalantixGrayscaleSize24 = mockComponent(
    'TalantixGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TalantixLiteSize16 = mockComponent(
    'TalantixLiteSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TalantixLiteSize24 = mockComponent(
    'TalantixLiteSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TalantixSolidSize16 = mockComponent(
    'TalantixSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TalantixSolidSize24 = mockComponent(
    'TalantixSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TelegramBrandSize16 = mockComponent(
    'TelegramBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TelegramBrandSize24 = mockComponent(
    'TelegramBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TelegramGrayscaleSize16 = mockComponent(
    'TelegramGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TelegramGrayscaleSize24 = mockComponent(
    'TelegramGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TelegramSolidSize16 = mockComponent(
    'TelegramSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TelegramSolidSize24 = mockComponent(
    'TelegramSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffBrandAltSize16 = mockComponent(
    'TinkoffBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffBrandAltSize24 = mockComponent(
    'TinkoffBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffBrandSize16 = mockComponent(
    'TinkoffBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffBrandSize24 = mockComponent(
    'TinkoffBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffGrayscaleSize16 = mockComponent(
    'TinkoffGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffGrayscaleSize24 = mockComponent(
    'TinkoffGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffIdBrandSize16 = mockComponent(
    'TinkoffIdBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffIdBrandSize24 = mockComponent(
    'TinkoffIdBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffIdGrayscaleSize16 = mockComponent(
    'TinkoffIdGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffIdGrayscaleSize24 = mockComponent(
    'TinkoffIdGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffIdSolidSize16 = mockComponent(
    'TinkoffIdSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffIdSolidSize24 = mockComponent(
    'TinkoffIdSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffSolidSize16 = mockComponent(
    'TinkoffSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TinkoffSolidSize24 = mockComponent(
    'TinkoffSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TwitterBrandSize16 = mockComponent(
    'TwitterBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TwitterBrandSize24 = mockComponent(
    'TwitterBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TwitterGrayscaleSize16 = mockComponent(
    'TwitterGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TwitterGrayscaleSize24 = mockComponent(
    'TwitterGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TwitterSolidSize16 = mockComponent(
    'TwitterSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TwitterSolidSize24 = mockComponent(
    'TwitterSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ViberBrandSize16 = mockComponent(
    'ViberBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ViberBrandSize24 = mockComponent(
    'ViberBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ViberGrayscaleSize16 = mockComponent(
    'ViberGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ViberGrayscaleSize24 = mockComponent(
    'ViberGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ViberSolidSize16 = mockComponent(
    'ViberSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ViberSolidSize24 = mockComponent(
    'ViberSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkBrandAltSize16 = mockComponent(
    'VkBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkBrandAltSize24 = mockComponent(
    'VkBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkBrandSize16 = mockComponent(
    'VkBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkBrandSize24 = mockComponent(
    'VkBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkGrayscaleSize16 = mockComponent(
    'VkGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkGrayscaleSize24 = mockComponent(
    'VkGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSolidSize16 = mockComponent(
    'VkSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSolidSize24 = mockComponent(
    'VkSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSquareBrandAltSize16 = mockComponent(
    'VkSquareBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSquareBrandAltSize24 = mockComponent(
    'VkSquareBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSquareBrandSize16 = mockComponent(
    'VkSquareBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSquareBrandSize24 = mockComponent(
    'VkSquareBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSquareGrayscaleSize16 = mockComponent(
    'VkSquareGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSquareGrayscaleSize24 = mockComponent(
    'VkSquareGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSquareSolidSize16 = mockComponent(
    'VkSquareSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VkSquareSolidSize24 = mockComponent(
    'VkSquareSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WhatsappBrandSize16 = mockComponent(
    'WhatsappBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WhatsappBrandSize24 = mockComponent(
    'WhatsappBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WhatsappGrayscaleSize16 = mockComponent(
    'WhatsappGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WhatsappGrayscaleSize24 = mockComponent(
    'WhatsappGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WhatsappSolidSize16 = mockComponent(
    'WhatsappSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WhatsappSolidSize24 = mockComponent(
    'WhatsappSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexBrandAltSize16 = mockComponent(
    'YandexBrandAltSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexBrandAltSize24 = mockComponent(
    'YandexBrandAltSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexBrandSize16 = mockComponent(
    'YandexBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexBrandSize24 = mockComponent(
    'YandexBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudBrandSize16 = mockComponent(
    'YandexCloudBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudBrandSize24 = mockComponent(
    'YandexCloudBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudBrandSize32 = mockComponent(
    'YandexCloudBrandSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudGrayscaleSize16 = mockComponent(
    'YandexCloudGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudGrayscaleSize24 = mockComponent(
    'YandexCloudGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudGrayscaleSize32 = mockComponent(
    'YandexCloudGrayscaleSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudSolidSize16 = mockComponent(
    'YandexCloudSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudSolidSize24 = mockComponent(
    'YandexCloudSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexCloudSolidSize32 = mockComponent(
    'YandexCloudSolidSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexGrayscaleSize16 = mockComponent(
    'YandexGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexGrayscaleSize24 = mockComponent(
    'YandexGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexSolidSize16 = mockComponent(
    'YandexSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const YandexSolidSize24 = mockComponent(
    'YandexSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ZarplataBrandSize16 = mockComponent(
    'ZarplataBrandSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ZarplataBrandSize24 = mockComponent(
    'ZarplataBrandSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ZarplataGrayscaleSize16 = mockComponent(
    'ZarplataGrayscaleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ZarplataGrayscaleSize24 = mockComponent(
    'ZarplataGrayscaleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ZarplataSolidSize16 = mockComponent(
    'ZarplataSolidSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ZarplataSolidSize24 = mockComponent(
    'ZarplataSolidSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);
